import api from '../api';

export const latest = (from = 0, amount = 20) => {
    return api.get(`/notifications/${from}/${amount}`);
};

export const read = (notifications) => {
    return api.post(`/notification/read`, {notifications: notifications});
};
